import httpClient from "./httpClient";

const API_PREFIX = "/v2/admin";

export default {
  ldapLogin(loginDto) {
    return httpClient.post(`${API_PREFIX}/ldap/gap`, loginDto);
  },
  kakaoLogin(accessToken) {
    return httpClient.post(`${API_PREFIX}/kakao`, {accessToken: accessToken});
  },
  ldapLogout() {
    return httpClient.post(`${API_PREFIX}/ldap/logout/gap`);
  },
  kakaoLogout() {
    return httpClient.post(`${API_PREFIX}/logout/gap`);
  },
  refresh() {
    return httpClient.get(`${API_PREFIX}/refresh`, {headers: {skipAlert: true}});
  },
}
